<template>
  <div :class="getDirectionalClassName" class="searchBox" @click="$emit('search-click')">
    <form>
      <fieldset>
        <legend class="screenReaderOnly">Enter your address to explore how your Congressional district has changed over time</legend>
        <MapboxSearch
              :showGeolocation="showGeolocation"
              :hideGeolocation="hideGeolocation"
              :updateLocation="updateLocation"
              :hidePlaceholder="hidePlaceholder"
              :placeholderText="placeholderText" />
        <Geolocation v-if="isMobile" :isVisible="isVisible" :updateLocation="updateLocation" :showLoading="showLoading" />
        <GeolocationAsText v-else :isVisible="true" :updateLocation="updateLocation" :showLoading="showLoading" />
      </fieldset>
    </form>
  </div>
</template>

<script>
import Geolocation from './Geolocation';
import GeolocationAsText from './GeolocationAsText';
import MapboxSearch from './MapboxSearch';

export default {
  components: {
    Geolocation,
    GeolocationAsText,
    MapboxSearch
  },
  props: {
    showAutocompleteBelow: {
      type: Boolean,
      default: false
    },
    updateLocation: {
      type: Function,
      default: () => {}
    },
    hidePlaceholder: {
      type: Boolean,
      default: false
    },
    showLoading: {
      type: Function,
      default: () => {}
    },
    placeholderText: {
      type: String,
      default: 'Search a location'
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    getDirectionalClassName() {
      return this.showAutocompleteBelow ? 'showAutocompleteBelow' : 'orotherclass'
    }
  },
  methods: {
    showGeolocation () {
      this.isVisible = true;
    },
    hideGeolocation () {
      this.isVisible = false;
    }
  }
}
</script>

<style lang="scss">
fieldset {
  border: none;
  padding: 0;
  text-align: left;
}
.searchBox {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBox.vue